// React for Website

import React from "react";
//outsource
import { Col, Typography, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
//components

const { Title } = Typography;

const VoucherSearch = ({ setSearch }) => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------

  return (
    <Input
      style={{ width: "80%" }}
      addonAfter={<SearchOutlined />}
      showSearch
      placeholder="Search by Voucher Name"
      allowClear
      onChange={(e) => setSearch(e.target.value)}
    />
  );
};

export default VoucherSearch;
